import {SystemApiPrefix as apiPrefix} from '~/utils/restApi'

const WIPS_URL = `${apiPrefix}/devices/wips`
const initSelectedDeviceInfo = () => {
  return {
    wips_device_id: void 0,
    cfg_admin_id: void 0,
    wips_device_ip: '',
    wips_device_port: 443,
    client_id: '',
    client_secret: '',
    wips_desc: '',
    cfg_dt: ''
  }
}

export const state = () => ({
  wipsDeviceList: [],
  selectedDeviceInfo: initSelectedDeviceInfo()
})

export const mutations = {
  resetSelectedDeviceInfo (state) {
    state.selectedDeviceInfo = initSelectedDeviceInfo()
  },
  initStore (state) {
    state.wipsDeviceList = []
    state.selectedDeviceInfo = initSelectedDeviceInfo()
  },
  setWipsDeviceList (state, payload) {
    state.wipsDeviceList = payload
  },
  setSelectedDeviceInfo (state, payload) {
    state.selectedDeviceInfo = payload
    state.selectedDeviceInfo.client_id = ''
    state.selectedDeviceInfo.client_secret = ''
  }
}

export const actions = {
  async getWipsDevice ({ commit }, deviceId = 0) {
    let res = {
      code: 'ok',
      result: {}
    }

    try {
      res = await this.$axios.$get(`${WIPS_URL}/${deviceId}`, {
        loading: true,
        successAlert: false
      })

      if (res.code === 'ok') {
        if (deviceId) {
          commit('setSelectedDeviceInfo', _.cloneDeep(_.get(res, ['result', 'wips_devices', '0'])))
        } else {
          commit('setWipsDeviceList', _.get(res, ['result', 'wips_devices']))
        }
      }
    } catch (e) {
      res.code = 'nok'
      res.result.msg = e.message
    }
    return res
  },

  async confirmWipsDevice ({ commit, state }, mode) {
    let res = {
      code: 'ok',
      result: {}
    }

    try {
      const param = {
        client_id: state.selectedDeviceInfo.client_id,
        client_secret: state.selectedDeviceInfo.client_secret,
        wips_desc: state.selectedDeviceInfo.wips_desc,
        wips_device_ip: state.selectedDeviceInfo.wips_device_ip,
        wips_device_port: state.selectedDeviceInfo.wips_device_port
      }

      const apiOption = {
        loading: true,
        successAlert: true
      }

      if (mode === 'ADD') {
        res = await this.$axios.$post(`${WIPS_URL}`, param, apiOption)
      } else if (mode === 'EDIT') {
        res = await this.$axios.$put(`${WIPS_URL}/${state.selectedDeviceInfo.wips_device_id}`, param, apiOption)
      }
    } catch (e) {
      res.code = 'nok'
      res.result.msg = e.message
    }

    return res
  },

  async removeWipsDevice ({ commit, state }, { wipsDeviceIdList }) {
    let res = {
      code: 'ok',
      result: {}
    }

    const param = {
      wips_device_id_list: wipsDeviceIdList
    }

    const apiOption = {
      loading: true,
      successAlert: true
    }

    try {
      res = await this.$axios.$delete(`${WIPS_URL}`, { data: param }, apiOption)
    } catch (e) {
      res.code = 'nok'
      res.result.msg = e.message
    }

    return res
  },

  async finalCommand ({ commit, state }, type) {
    let res = {
      code: 'ok',
      result: {}
    }

    try {
      const apiOption = {
        loading: false
      }

      if (type === 'apply') {
        apiOption.applyMsg = true
      } else if (type === 'cancel') {
        apiOption.cancelMsg = true
      }

      res = await this.$axios.$put(`${WIPS_URL}/${type}`, void 0, apiOption)
    } catch (e) {
      res.code = 'nok'
      res.result.msg = e.message
    }

    return res
  }
}
export const getters = {}
export const strict = false
